var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copy-right"},[_c('span',[_vm._v("版权所有@2021-2022 轩辕方舟")]),_c('p',{staticClass:"beian"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(" 京ICP备2023013970号")])])])])
}]

export { render, staticRenderFns }